import FlowerTitle from "../components/ui/FlowerTitle";
import StrokeTitle from "../components/ui/StrokeTitle";
import ReactPlayer from "react-player";

const Media = () => (
  <div className="page-container">
    <FlowerTitle text="Gallery"/>
    <StrokeTitle text="Launch Trailer"/>
    <div className="video-container">
      <div className="video-wrapper">
        <ReactPlayer url="https://youtu.be/2kU6zhLiQYE"/>
      </div>
    </div>
    <StrokeTitle text="Anything Goes"/>
    <div className="video-container">
      <div className="video-wrapper">
        <ReactPlayer url="https://youtu.be/cGPX50LN0EI"/>
      </div>
    </div>
    <StrokeTitle text="Announcement Trailer"/>
    <div className="video-container">
      <div className="video-wrapper">
        <ReactPlayer url="https://youtu.be/8xnit7IbIZ8"/>
      </div>
    </div>
  </div>
)


export default Media;